import React from "react";
import SkeletonLoader from "shrimmer/SkeletonLoader";
import { createArray } from "utils/surveyHelper";

const SurveyInfoShimmer = () => {
  return (
    <div className="form_summery">
      <>
        <h4>
          <SkeletonLoader type={"text"} height={35} width={400} />
        </h4>
        <h6>
          <SkeletonLoader type={"text"} height={35} width={400} />
        </h6>
        <ul>
          {createArray(5).map((index) => {
            return (
              <li key={index}>
                <b>
                  <SkeletonLoader type={"text"} height={25} width={180} bottomGap={8}/>
                </b>
                <p>
                  <SkeletonLoader type={"text"} count={3.75} height={23} width={380} />
                </p>
              </li>
            );
          })}
        </ul>
      </>
    </div>
  );
};

export default SurveyInfoShimmer;
